const Form016EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicationInformation: "Application Information",
        confirmation: "Confirmation",
    },

    importantNotesContent: {
        title: "Notes",
        p1: "Please make ready the scanned copies / images of the supporting documents in the file format of JPG, PNG or PDF if necessary:",
        p1Annotion: "(The maximum size of all files should not exceed 10MB.)",
        p2: 'You need an "iAM Smart" account with digital signing function for the online application form.',
        p3: "Please submit the professional development portfolio (with action research project attached as an attachment) in duplicate together with this application form:-",
        p3Point1:
            "by hand to the Professional Development and Training Division, Education Bureau on 5/F,East Wing, Central Government Offices, 2 Tim Mei Avenue, Tamar, Hong Kong. (Please ring up the School Leadership and Professional Development Section on 3509 7471 at least 2 working days prior to the submission to facilitate the pre-registration for entry to the Central Government Offices); ",
        p3Point1BoldText: "OR",
        p3Point2:
            "by registered mail to the School Leadership and Professional Development Section,Professional Development and Training Division, Education Bureau, 5/F, East Wing, Central Government Offices, 2 Tim Mei Avenue, Tamar, Hong Kong.",
        iamSignCheck:
            "I understand applicant needs to have an “iAM Smart+” account to process the application.",
    },

    applicationInformationContent: {
        label: {
            refNo: "Ref No.:",
            refNoTxtAfterField: "(For office use only)",

            circularNumber: "No. 2/2019",
            refNO: "A123",

            formTitle: "Personal Information",
            nameOfApplicationEn:
                "Name of Applicant (must be identical with that of the applicant's HK Identity Card)(English)",
            nameOfApplicationCh:
                "Name of Applicant (must be identical with that of the applicant's HK Identity Card)(Chinese, if applicable)",
            sex: "Sex",
            sexOption: {
                male: "Male",
                female: "Female",
            },
            mailingAddress: "Correspondence Address",
            schoolOrOffice: "Contact Telephone No.(School / Office)",
            schoolOrOfficeOption: {
                school: "School Contact Telephone No.",
                office: "Office Contact Telephone No.",
            },
            workTel: "Contact Telephone No.",
            homeOrMobile: "Contact Telephone No.(Home / Mobile)",
            homeOrMobileOption: {
                home: "Home Contact Telephone No.",
                mobile: "Mobile Contact Telephone No.",
            },
            privateTel: "Contact Telephone No.",
            fax: "Fax No.",
            email: "E-mail Address",
            hkidOrPassport: "HK Identity Card / Passport No",
            hkidOrPassportOption: {
                hkid: "HK Identity Card",
                passportNo: "Passport No",
            },
            hkid: "HK Identity Card",
            passportNo: "Passport No",
            rtOrPt: "Registered Teacher / Permitted Teacher",
            rtOrPtOption: {
                rtNo: "Registered Teacher",
                ptNo: "Permitted Teacher",
            },
            rtNo: "Registered Teacher No.",
            ptNo: "Permitted Teacher No.",
            schoolOrOrganisation:
                "Name and Address of Applicant's School / Organisation",
            schoolOrOrganisationOption: {
                school: "School",
                organisation: "Organisation",
            },
            schoolName: "Name of Applicant's ",
            schoolAddress: "Address of Applicant's ",
            schoolType: "Type of School (if applicable)",
            schoolTypeOption: {
                primary: "Primary",
                secondary: "Secondary",
                special: "Special",
            },
            schoolTypeOption2: {
                government: "Government",
                aided: "Aided",
                dss: "DSS",
                others: "Others",
            },
            otherSchoolType: "Others (Please specify)",
            certificationTitle: "Professional Qualification(s)",
            certificationName:
                "Teacher Training (e.g. a local Teacher's Certificate or Post-graduate Diploma / Certificate in Education or Bachelor of Education degree or equivalent)",
            awardingInstituteName: "Name of Awarding Institute",
            awardDate: "Date(s) of Award",
            teachingExperience: "Teaching Experience",
            teachingExperienceOption: {
                five: "5 Years",
                ten: "6-10 Years",
                fifteen: "11-15 Years",
                overFifteen: "over 15 Years",
            },
            curSchoolOrOrganisation:
                "Current Position in School / Organisation",
            curSchoolOrOrganisationOption: {
                schoolPost: "School",
                organisationPost: "Organisation",
            },
            schoolPost: "Current Position in School",
            organisationPost: "Current Position in Organisation",
            completeDate: "Needs Analysis Completion Date",
            commencementDate:
                "Preparation for Principalship Course Commencement Date",
            courseAwardDate:
                "Preparation for Principalship Course Date of Award",

            isDeclarationTitle: "Declaration",
            declarationP1: "I declare,",
            // declarationContentList: [
            //     "that I have read and understood the Guidelines on Professional Development Portfolio for Aspiring Principals (Annex A);",
            //     "that the personal data entered in my application form and all the factual information contained in my professional development portfolio for this application are true and accurate;",
            //     "that the action research project mentioned in my professional development portfolio is the one I did in the Preparation for Principalship Course; and",
            //     "that the professional development portfolio is entirely my own work except where I have duly acknowledged other sources and put the copied parts in quotations in the portfolio. The professional development portfolio is in compliance with the copyright laws#.",
            // ],
            declarationP2:
                "that I have read and understood the Guidelines on Professional Development Portfolio for Aspiring Principals (Annex A);",
            declarationP3:
                "that the personal data entered in my application form and all the factual information contained in my professional development portfolio for this application are true and accurate;",
            declarationP4:
                "that the action research project mentioned in my professional development portfolio is the one I did in the Preparation for Principalship Course; and",
            declarationP5:
                "that the professional development portfolio is entirely my own work except where I have duly acknowledged other sources and put the copied parts in quotations in the portfolio. The professional development portfolio is in compliance with the copyright laws",
            // "that the professional development portfolio is entirely my own work except where I have duly acknowledged other sources and put the copied parts in quotations in the portfolio. The professional development portfolio is in compliance with the copyright laws#.",
            // ],
            attachment: "Annex",
            completedByEDB: "To be completed by the Education Bureau",
        },
        annotation: {
            hash: "Please note that if your professional development portfolio is not in compliance with the copyright laws, it may lead to your CFP application being rejected. Under such circumstances, a fresh CFP application will not be accepted by the Education Bureau until after a lapse of one year counting from the date of your last submission. It may also lead to more serious consequences (e.g. a review of your teacher registration status) depending on the severity of the matter.",
        },

        errorMsg: {
            nameOfApplicationEn: "name of applicant in English",
            nameOfApplicationCh: "name of applicant in Chinese",
            mailingAddress: "Correspondence Address",
        },
    },

    submittedDialog: {
        note1: "The application is submitted successfully.",
        note2: "Please submit the professional development portfolio (with action research project attached as an attachement) in duplicate together ",
        note3: "with this application form",
        note4: ":-",
        note5: "",
        note6: ":-",
        note7: "by hand to the Professional Development and Training Division, Education Bureau on 5/F, East Wing, Central Government Offices, 2 Tim Mei Avenue, Tamar, Hong Kong. (Please ring up the School Leadership and Professional Development Section on 3509 7471 at least 2 working days prior to the submission to facilitate the pre-registration for entry to the Central Government Offices); OR",
        note8: "by registered mail to the School Leadership and Professional Development Section, Professional Development and Training Division, Education Bureau, 5/F, East Wing, Central Government Offices, 2 Tim Mei Avenue, Tamar, Hong Kong.",
    },
};
export default Form016EN;
